import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/common/Layout";
import DevelopmentProjects from "./components/landingPage/projects/DevelopmentProjects";
import DesignProjects from "./components/landingPage/projects/DesignProjects";

import Resume from "./components/resume/ResumeShowCase";
import Blogs from "./components/blogs/Blogs";
import ArticlePage from "./components/articles/ArticlePage";
import CreatorStudio from "./components/editor/CreatorStudio";
import ToolsPage from "./components/tools/ToolsPage";
import UUIDGenerator from "./components/tools/features/UUIDGenerator";
import JSONFormatter from "./components/tools/features/JSONFormatter";
import ColorConverter from "./components/tools/features/ColorConverter";

function App() {
  const resumeUrl =
    "https://drive.google.com/file/d/1jnZ5DTq0_9K-uPHAR7kMpcKuPyrlzuwu/view?usp=sharing";
  const coverImageUrl = "";

  const host = window.location.host;

  if (host === "resume.bharatpahwa.dev") {
    return <Resume url={resumeUrl} coverImage={coverImageUrl} />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route
            path="/resume"
            element={<Resume url={resumeUrl} coverImage={coverImageUrl} />}
          />
          <Route path="/create" element={<CreatorStudio />} />
          <Route path="/devprojects" element={<DevelopmentProjects />} />
          <Route path="/designprojects" element={<DesignProjects />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />

          {/* App.js Routing Snippet */}
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/tools/uuid-generator" element={<UUIDGenerator />} />
          <Route path="/tools/json-formatter" element={<JSONFormatter />} />
          <Route path="/tools/color-converter" element={<ColorConverter />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
